<template>
  <div>
    <el-upload
        name="files[]"
        :action="action"
        ref="upload"
        list-type="picture-card"
        :on-preview="handlePictureCardPreview"
        :file-list="value"
        :auto-upload="true"
        multiple
        :disabled="disabled || value.length >= maxCount"
        @change="change"
        :limit="maxCount"
        :on-exceed="limitAlert"
    >
      <i class="el-icon-plus" v-if="value.length < maxCount"></i>
      <span v-else>最多{{ maxCount }}张</span>
    </el-upload>
    <el-dialog v-model="dialogVisible">
      <el-image
          style="width: 100%;"
          :src="dialogImageUrl"
      ></el-image>
    </el-dialog>
  </div>
</template>
<script>
import config from '../request/config'

export default {
  model: {
    event: 'change',
    prop: 'value'
  },
  props: {
    value: {
      type: Array,
      default: () => ([])
    },
    maxCount: {
      type: Number,
      default: 4
    },
    disabled: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      dialogImageUrl: '',
      dialogVisible: false
    }
  },
  methods: {
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url
      this.dialogVisible = true
    },
    change({status}){
      if(status === 'ready'){
        this.$emit('update:loading', true)
      }else if(status === 'success'){
        this.$emit('update:loading', false)
      }
    },
    limitAlert(){
      alert(`最多${this.maxCount}张`)
    }
  },
  computed: {
    action() {
      return `${config.baseUrl}/tmp_files`
    }
  }
}
</script>
